export const parseCsvImportFormValues = values => ({
	headers: Object.keys(values)
		.filter(key => key.startsWith('header-'))
		.sort((a, b) => Number(a.split('-')[1]) - Number(b.split('-')[1]))
		.map(key => values[key]),
	tagIds: values.tagIds || [],
	listIds: values.listIds || [],
});
